import React, { Component } from "react";
import PropTypes from "prop-types";

import {
    DialogBox,
    DialogBoxFooterType,
    NoLink,
    Section,
    SelectInput,
    SubSection,
    ZeroToInfiniteGrid,
} from "~/core";
import { withEditableGrid } from "~/hocs";
import {
    getAgBytesErrorClassNames,
    mapToPicklistValue,
    prepareSelectableOptions,
} from "~/admin/utils";
import { adminData, GUID, NAME } from "~/admin/data";
import { messages } from "./../i18n-messages";
import { createAddEditModalTitle, createAddLinkLabelText } from "~/i18n-messages";

const PROPS_IMPORT_ATTRIBUTE = "importAttribute";
const PROPS_IMPORT_ATTRIBUTE_GUID = "importAttributeGuid";

class ImportAttributeList extends Component {
    static propTypes = {
        apiErrors: PropTypes.array,
        deleteItem: PropTypes.func,
        editData: PropTypes.object,
        formatMessage: PropTypes.func,
        getUpdatedLists: PropTypes.func,
        isDeleting: PropTypes.bool,
        isEditing: PropTypes.bool,
        onAdd: PropTypes.func,
        onAddOrEditItem: PropTypes.func,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        onEdit: PropTypes.func,
        picklistOptions: PropTypes.object,
        record: PropTypes.array,
        renderDeleteModal: PropTypes.func,
        toggleModal: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            editingItem: false,
            importAttribute: [],
            records: [],
            lastRecord: null,
            lastImportAttributeOptions: null,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { record, picklistOptions = {} } = nextProps;
        const importAttributeOptions = picklistOptions[PROPS_IMPORT_ATTRIBUTE];
        if (
            record === prevState.lastRecord &&
            importAttributeOptions === prevState.lastImportAttributeOptions
        ) {
            return null;
        }
        const records = (record || []).map((recordItem) => {
            const selectedImportAttribute = (importAttributeOptions || []).find(
                (importAttributeItem) =>
                    importAttributeItem[GUID] === recordItem[PROPS_IMPORT_ATTRIBUTE_GUID]
            );
            return {
                ...recordItem,
                [PROPS_IMPORT_ATTRIBUTE]:
                    (selectedImportAttribute && selectedImportAttribute[NAME]) ||
                    recordItem[PROPS_IMPORT_ATTRIBUTE],
            };
        });
        return {
            records,
            lastRecord: record,
            lastImportAttributeOptions: importAttributeOptions,
        };
    }

    initializeDropdowns = (options) => {
        this.setState({
            importAttribute: prepareSelectableOptions(options[PROPS_IMPORT_ATTRIBUTE], {
                guid: GUID,
                label: NAME,
            }),
        });
    };

    onAdd = () => {
        this.initializeDropdowns(this.props.picklistOptions, {});
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    onDelete = (record, index) => {
        this.props.onDelete({ record, index });
    };

    onEdit = (record, index) => {
        this.initializeDropdowns(this.props.picklistOptions, record);
        this.setState({ editingItem: true });
        const keysToUpdate = [
            {
                name: [PROPS_IMPORT_ATTRIBUTE_GUID],
                key: GUID,
            },
        ];
        this.props.onEdit({ record, index, keysToUpdate });
    };

    renderAddEditModal = () => {
        const { editData, formatMessage, isEditing, onAddOrEditItem, onChange, toggleModal } =
            this.props;
        const formData = { ...editData };
        return (
            <DialogBox
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                action="save"
                isOpen={isEditing}
                forceOverflow
                hideCloseX
                actionDisabled={!editData[PROPS_IMPORT_ATTRIBUTE_GUID]}
                onAction={() => onAddOrEditItem()}
                onClose={() => toggleModal("isEditing", false)}
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.importAttribute
                )}
            >
                <div className="dialog-box-select">
                    <Section>
                        <SubSection>
                            <SelectInput
                                required
                                tabIndex={0}
                                optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                                options={this.state.importAttribute}
                                placeholderText={formatMessage(messages.importAttribute)}
                                value={mapToPicklistValue({
                                    options: this.state.importAttribute,
                                    selectedGuid: formData[PROPS_IMPORT_ATTRIBUTE_GUID],
                                })}
                                onChange={(newValue) => {
                                    onChange({
                                        [PROPS_IMPORT_ATTRIBUTE_GUID]: newValue
                                            ? newValue.guid
                                            : null,
                                    });
                                }}
                            />
                        </SubSection>
                    </Section>
                </div>
            </DialogBox>
        );
    };

    render() {
        const { formatMessage } = this.props;
        const { records } = this.state;
        return (
            <div className={"form-section-child-stretch mini-grid"}>
                {!(records && records.length > 0) ? null : (
                    <ZeroToInfiniteGrid
                        records={records}
                        columns={{
                            [PROPS_IMPORT_ATTRIBUTE]: {
                                title: formatMessage(messages.importAttribute),
                            },
                        }}
                        className={"cell-stretch"}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {this.props.renderDeleteModal()}
                <div className="add-link-container">
                    <NoLink
                        classNames={getAgBytesErrorClassNames(128, this.props.apiErrors, [
                            "add-link",
                        ])}
                        label={createAddLinkLabelText(formatMessage, messages.importAttribute)}
                        onClick={this.onAdd}
                    ></NoLink>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(ImportAttributeList);
